module.exports = __webpack_public_path__ + "img/multi-package-new.ebed6c4b.svg";